import styled from "styled-components";

export const CalendarWeekWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: 0;
  align-items: center;
  justify-content: space-between;
`;
